// src/pages/home/Home.tsx
import { useState, useEffect, useCallback } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import { Box } from "@mui/material";
import "../../components/layout/pageLayout.scss";

const MOBILE_BREAKPOINT = 768;

const Home = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isMobile, sidebarOpen]);

  const handleToggle = useCallback(() => setSidebarOpen((v) => !v), []);
  const handleClose = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="pageContainer">
      {isMobile && sidebarOpen && (
        <div className="sidebar-backdrop" onClick={handleClose} />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={handleClose} isMobile={isMobile} />

      <div className="contentContainer">
        <Navbar onMenuToggle={handleToggle} />

        <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 }, bgcolor: "background.default", minHeight: "calc(100vh - 64px)" }}>
          {/* Widgets row */}
          <Box sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr", lg: "1fr 1fr 1fr 1fr" },
            gap: { xs: 1.5, sm: 2, md: 2.5 },
            mb: { xs: 2, md: 3 },
          }}>
            <Widget type="ventas" />
            <Widget type="pendientes" />
            <Widget type="devoluciones" />
            <Widget type="balance" />
          </Box>

          {/* Charts row */}
          <Box sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
            gap: { xs: 1.5, sm: 2, md: 2.5 },
            mb: { xs: 2, md: 3 },
          }}>
            <Featured />
            <Chart aspect={2 / 1} title="Últimos 3 Meses (Ventas)" />
          </Box>

          {/* Table */}
          <Table />
        </Box>
      </div>
    </div>
  );
};

export default Home;
